<script lang="ts">
    import FeatherIcon from "svelte-feather-icon";
    import Link from "svelte-link";
    import { Button, Input, InputGroup } from "sveltestrap";
    import { cart} from "../../../../store";
    import { href } from "../../../../utils/Constant/Constant";
    import {handleCart,decrementQty} from "../../../../Data/Ecommerce/Cartdata"
    import CartTotal from "./CartTotal.svelte";
    import CartDetail from "./CartDetail.svelte";
    let setCart:any
    cart.subscribe((value)=>{
      setCart = value
    })
    // for quantity add
    const plusQtyItem = (item:any,qty:number) => {
        handleCart(item,qty)
    };
    // for quantity minus
    const minusQtyItem = (id:number) => {
        decrementQty(id)
    };
    // for cart on remove product
    const removeFromCart = (id:number) => {
        cart.update(
            (value) => (value = setCart.filter((ele) => ele.id !== id))
        );
    };
</script>

{#each setCart as productItem}
    <tr>
        <CartDetail productItem={productItem}/>
        <td>$ {productItem.price}</td>
        <td>
            <fieldset class="qty-box">
                <InputGroup>
                    <Button color="light" on:click={() => minusQtyItem(productItem.id)}>-</Button>
                    <Input class="touchspin text-center" type="text" bind:value={productItem.qty} readonly/>
                    <Button color="light" on:click={() => plusQtyItem(productItem,1)}>+</Button>
                </InputGroup>
            </fieldset>
        </td>
        <td>
            <Link {href} on:click={() => removeFromCart(productItem.id)}>
                <FeatherIcon icon="x-circle" />
            </Link>
        </td>
        <td>{productItem.price * productItem.qty}</td>
    </tr>
{/each}
<CartTotal />
